module.exports = __webpack_public_path__ + "static/media/Mutuality Means.809926fd.pdf";